<template>
  <div class="miya-proxyCountry">
    <el-scrollbar style="height:100%;">
      <div class="pageBox">
        <h1 class="title1 fontSH">{{$t('pCountry.title1')}}</h1>
        <proxy-data :dataList="dataList" path='/purchaseTraffic' @click="clickBuy()"></proxy-data>    
        <div class="title2"><img src="@assets/images/home/price-icon1.png"><span>{{$t('dashboard.titleCountry')}}</span></div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <div class="fromItem-box">
            <div class="row">
              <p class="name">
                <span>{{$t('pCity.position')}}</span>
                <el-tooltip class="item" effect="dark" :content="$t('pCity.positionTip')" placement="bottom">
                  <img src="@assets/images/icon/tip.svg">
                </el-tooltip>
              </p>
              <el-form-item label="" prop="network" label-width="0">
                <el-select size="medium" :placeholder="$t('pCountry.selectPlaceholder')" v-model="ruleForm.network">
                  <el-option v-for="(item, idx) in networkList" :key="'network'+idx" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="row">
              <p class="name">
                <span>{{$t('pCountry.type')}}</span>
                <el-tooltip class="item" effect="dark" :content="$t('pCountry.typeTip')" placement="bottom">
                  <img src="@assets/images/icon/tip.svg">
                </el-tooltip>
              </p>
              <el-form-item label="" prop="type" label-width="0">
                <el-select size="medium" :placeholder="$t('pCountry.selectPlaceholder')" v-model="ruleForm.type" @change="changePool()">
                  <el-option v-for="(item, idx) in typeList" :key="'network'+idx" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="row">
              <p class="name">
                <span>{{$t('pCountry.country')}}</span>
                <!-- <el-tooltip class="item" effect="dark" :content="$t('pCountry.countryTip')" placement="bottom">
                  <img src="@assets/images/icon/tip.svg">
                </el-tooltip> -->
              </p>
              <el-form-item label="" prop="contry" label-width="0">
                <el-select size="medium" :placeholder="$t('pCountry.selectPlaceholder')" filterable="" v-model="ruleForm.contry">
                  <el-option v-for="(item, idx) in countryList" :key="'network'+idx" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="row">
              <p class="name">
                <span>{{$t('pCountry.time')}}</span>
                <el-tooltip class="item" effect="dark" :content="$t('pCountry.timeTip')" placement="bottom">
                  <img src="@assets/images/icon/tip.svg">
                </el-tooltip>
              </p>
              <el-form-item label="" prop="time" label-width="0">
                <el-select size="medium" :placeholder="$t('pCountry.selectPlaceholder')" v-model="ruleForm.time">
                  <el-option v-for="(item, idx) in timeList" :key="'network'+idx" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="row">
              <p class="name">
                <span>{{$t('pCountry.generationType')}}</span>
                <!-- <el-tooltip class="item" effect="dark" :content="$t('pCountry.generationTypeTip')" placement="bottom">
                  <img src="@assets/images/icon/tip.svg">
                </el-tooltip> -->
              </p>
              <el-form-item label="" prop="generationType" label-width="0">
                <el-select size="medium" :placeholder="$t('pCountry.selectPlaceholder')" v-model="ruleForm.generationType">
                  <el-option v-for="(item, idx) in generationTypeList" :key="'network'+idx" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="row">
              <p class="name">
                <span>{{$t('pCountry.num')}}</span>
                <!-- <el-tooltip class="item" effect="dark" :content="$t('pCountry.numTip')" placement="bottom">
                  <img src="@assets/images/icon/tip.svg">
                </el-tooltip> -->
              </p>
              <el-form-item label="" prop="num" label-width="0">
                <el-input-number size="medium" :placeholder="$t('pCountry.inputPlaceholder')" v-model="ruleForm.num" :min="1" :step-strictly="true" :controls="false"></el-input-number>
              </el-form-item>
            </div>
          </div>
        </el-form>
        <div class="row api-row">
          <p class="name">
            <span>{{$t('pCountry.api')}}</span>
            <el-tooltip class="item" effect="dark" :content="$t('pCountry.apiTip')" placement="bottom">
              <img src="@assets/images/icon/tip.svg">
            </el-tooltip>
            <el-switch v-model="ruleForm.api" active-color="#FF8F10" inactive-color="#D0CFCE"></el-switch>
            <span class="text">{{$t('pCountry.apiText')}}</span>
          </p>
        </div>
        <div class="operation-box">
          <div class="btn-box">
            <div class="btn generation"><miya-btn ref="miyaBtn1" @click="clickGenerate()" :title="$t('pCountry.btnGeneration')" class="btn"></miya-btn></div>
            <div class="btn copy"><p class="btnCopy copyBtn1" :data-clipboard-text="text1" @click="clickCopye('copyBtn1')"><i class="icon"></i>{{$t('pCountry.copy')}}</p></div>
          </div>
          <div class="textarea">
            <div class="text">
              <p v-if="textarea1" v-for="(item, idx) in textarea1" :key="'proxy4'+idx">{{item}}</p>
            </div>
          </div>
        </div>
        <div class="operation-box">
          <div class="btn-box">
            <el-button class="btn-api miyaBtnInfo" type="info" style="width:100%;" size="medium" plain @click="clickGenerateAPI()">{{$t('pCountry.exportApi')}}</el-button>
            <div class="btn copy"><p class="btnCopy copyBtn2" :data-clipboard-text="apiText" @click="clickCopye('copyBtn2')"><i class="icon"></i>{{$t('pCountry.copy')}}</p></div>
          </div>
          <div class="textarea">
            <div class="text text1">
              <p v-if="textarea2" v-for="(item, idx) in textarea2" :key="'api4'+idx">{{item}}</p>
            </div>
          </div>
        </div>
        <div class="operation-box">
          <div class="btn-box"></div>
          <div class="textarea qrcode-box">
            <div class="textarea-box">
              <el-input :rows="3" type="textarea" v-model="copyText" :placeholder="$t('pCountry.qrPlaceholder')"></el-input>
              <el-button type="info" size="medium" class="btnQrcode" @click="showQrcode()">{{$t('pCountry.btnQrcode')}}</el-button>
              <p class="socksName">{{$t('pCountry.socks5Name')}}</p>
            </div>
            <div class="qrcode-box" v-loading="loadingCode">
              <div id="QRImg" ref="QRImg" v-show="isShowQrcode"></div>
              <span class="emptyText" v-show="!isShowQrcode">{{$t('pCountry.emptyQr')}}</span>
            </div>
          </div>
        </div>
      </div>
    </el-scrollbar>
  </div>
</template>
<script>
import proxyData from '@components/proxyData.vue'
import miyaBtn from '@components/miyaBtn.vue'
import {networkList, countryList_1, countryList_2} from '@assets/js/data.js'
import QRCode from 'qrcodejs2';
import { Base64 } from 'js-base64'
import { mapGetters, mapActions } from "vuex";
export default {
  data () {
    return {
      dataList: [
        {name: '', value: 0},
        {name: '', value: 0},
        {name: '', value: 0},
      ],
      networkList: networkList,
      countryList: countryList_2,
      typeList: [
        {label: 'IP POOL 1', value: '1'},
        {label: 'IP POOL 2', value: '2'},
      ],
      timeList: [
        {label: '5 minutes', value: 5},
        {label: '10 minutes', value: 10},
        {label: '15 minutes', value: 15},
        {label: '30 minutes', value: 30},
        {label: '60 minutes', value: 60},
        {label: '120 minutes', value: 120},
      ],
      generationTypeList: [
        {label: 'http(s)', value: '1'},
        {label: 'socks5', value: '2'},
      ],
      ruleForm: {
        network: 'as',
        contry: 'us',
        type: '1',
        time: 30,
        generationType: '2',
        num: 1,
        api: false,
      },
      rules: {
      },
      text1: '',
      apiText: '',
      copyText: '',
      isShowQrcode: false,
      loadingCode: false,
    }
  },
  computed: {
    textarea1 () {
      if (this.text1.length > 0) {
        let arr = this.text1.split('\n')
        return arr
      }
      return ''
    },
    textarea2 () {
      if (this.apiText.length > 0) {
        let arr = this.apiText.split('\n')
        return arr
      }
      return ''
    },
    ...mapGetters(["user"])
  },
  mounted () {  
    this.getData()
  },
  methods: {
    getData () {
      this.dataList[0].name = this.$t('dashboard.dataName1')
      this.dataList[1].name = this.$t('dashboard.dataName2')
      this.dataList[2].name = this.$t('dashboard.dataName3')
      this.$get(`/usage/getbandwidth?mealType=1`).then(res => {
        if (res.code === 200) {
          this.dataList[0].value = Number((res.result.totalBandWidth / 1000000000).toFixed(2))
          this.dataList[1].value = Number((res.result.usedBandWidth / 1000000000).toFixed(2))
          this.dataList[2].value = Number(((res.result.totalBandWidth - res.result.usedBandWidth) / 1000000000).toFixed(2))
        }
      })
    },
    changePool () { // pool1 pool2
      if (this.ruleForm.type === '1') {
        this.timeList = [
          {label: '5 minutes', value: 5},
          {label: '10 minutes', value: 10},
          {label: '15 minutes', value: 15},
          {label: '30 minutes', value: 30},
          {label: '60 minutes', value: 60},
          {label: '120 minutes', value: 120},
        ]
        this.ruleForm.time = 30
        this.countryList = countryList_2
      } else if (this.ruleForm.type === '2') {
        this.timeList = [
          {label: '5 minutes', value: 5},
          {label: '10 minutes', value: 10},
          {label: '15 minutes', value: 15},
          {label: '30 minutes', value: 30},
          {label: '60 minutes', value: 60},
          {label: '120 minutes', value: 120},
        ]
        this.ruleForm.time = 30
        this.countryList = countryList_1
      }
      this.ruleForm.contry=''
    },
    clickGenerate () {
      this.getIPAddress().then((ip) => {
          var date = new Date();
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const day = String(date.getDate()).padStart(2, "0");
          const hours = String(date.getHours()).padStart(2, "0");
          const minutes = String(date.getMinutes()).padStart(2, "0");
          const seconds = String(date.getSeconds()).padStart(2, "0");

          // 替换格式字符串中的占位符
          var createTime = "yyyy-MM-dd HH:mm:ss"
            .replace("yyyy", year)
            .replace("MM", month)
            .replace("dd", day)
            .replace("HH", hours)
            .replace(
              "hh",
              hours > 12 ? String(hours - 12).padStart(2, "0") : hours
            )
            .replace("mm", minutes)
            .replace("ss", seconds)

          this.$post(`/SysLogs/Add`, {
            Content: "",
            TypeName: "生成动态代理",
            TypeId: "",
            Href: "",
            CreateTime: createTime,
            CreateId: this.user.account,
            CreateName: this.user.account,
            Ip: ip,
            Result: 0,
            Application: "web",
          });
        });

      let params = {
        apiSwitch: this.ruleForm.api ? 1 : 0,
        mealType: 1,
        pool: this.ruleForm.type,
        proxynet: this.ruleForm.network,
        genType: this.ruleForm.generationType,
        country: this.ruleForm.contry,
        expireTime: this.ruleForm.time,
        city: '',
        num: this.ruleForm.num
      }
      this.$get(`/ProxyGenerage/GenerateProxy`, params).then(res => {
        if (res.code === 200) {
          this.text1 = res.result
        } else {
          this.$message.error(res.message)
        }
      })
    },
    clickGenerateAPI () {
      this.$get(`/check/GetSecret`).then(res => {
        if (res.code === 200) {
          let result = res.result
          let params = {
            apiSwitch: this.ruleForm.api ? 1 : 0,
            mealType: 1,
            pool: this.ruleForm.type,
            proxynet: this.ruleForm.network,
            genType: this.ruleForm.generationType,
            country: this.ruleForm.contry,
            expireTime: this.ruleForm.time,
            city: '',
            num: this.ruleForm.num
          }
          let str = ``
          for(let i in params) {
            str += `${i}=${params[i]}&`
          }
          this.apiText = `${window.hostUrl}api/ProxyGenerage/PublicGenerateProxy?${str}${result}`
        }
      })
    },
    clickCopye (btn) {
      var clipboard = new this.Clipboard(`.${btn}`)
      clipboard.on('success', () => {
        this.$message.success(this.$t('reward.copySuccess'))
        clipboard.destroy()
      })
      clipboard.on('error', () => {
        this.$message.error(this.$t('reward.copyError'))
        clipboard.destroy()
      })
    },
    showQrcode () {
      this.isShowQrcode = true
      this.loadingCode = true
      if (this.copyText) {
        this.getQrCode(this.copyText)
      } else {
        let params = {
          apiSwitch: this.ruleForm.api ? 1 : 0,
          mealType: 1,
          pool: this.ruleForm.type,
          proxynet: this.ruleForm.network,
          genType: this.ruleForm.generationType,
          country: this.ruleForm.contry,
          expireTime: this.ruleForm.time,
          city: '',
          num: this.ruleForm.num
        }
        this.$get(`/ProxyGenerage/GenerateProxy`, params).then(res => {
          if (res.code === 200) {
            this.copyText = res.result
            this.getQrCode(this.copyText)
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    getQrCode (proxy) {
      const proxySplit = proxy.split(':')
      this.loadingCode = false
      if (proxySplit.length < 4) {
        this.$message.error(this.$t('pCountry.qrcodeError'))
        this.isShowQrcode = false
        return
      }
      $(`#QRImg`).html('')
      let str = Base64.encode(`${proxySplit[2]}:${proxySplit[3]}@${proxySplit[0]}:${proxySplit[1]}`)
      let codeString = `socks://${str}?obfs=none`
      let qr = new QRCode(this.$refs.QRImg, {width: 138, height: 138})
      qr.makeCode(codeString)    
    },
    async getIPAddress() {
      const ipServices = [
        "https://ipinfo.io/json",
        "https://api.ipify.org?format=json",
        "https://ipapi.co/json/",
        "https://api.my-ip.io/ip.json",
      ];
      try {
        // 尝试多个API直到成功
        for (const service of ipServices) {
          try {
            const response = await fetch(service);

            if (!response.ok) {
              throw new Error(`API服务不可用: ${service}`);
            }

            const data = await response.json();

            // 不同API返回的数据结构不同
            const ip = data.ip || data.ip_address || data.query;

            if (ip) {
              return ip;
            }
          } catch (err) {
            console.log(`服务失败: ${service}`, err);
          }
        }

        // 所有服务都失败
        throw new Error("无法从任何服务获取IP地址");
      } catch (error) {
        console.error("获取IP地址失败:", error);
      }
    },
    clickBuy () {
      this.$router.push({path: '/purchaseTraffic', query: {type: 'country'}})
    },
  },
  beforeDestroy () {
  },
  watch: {
    language () {
      this.getData()
    },
  },
  components: {proxyData, miyaBtn}
}
</script>
<style scoped lang="stylus">
.miya-proxyCountry
  height 100%
  overflow-y hidden
  .pageBox
    padding 40px 40px 24px 40px
  .title1
    color $c1
    font-size 28px
    margin 10px 0 32px 0
  .title2
    display flex
    line-height 24px
    color $c8
    font-size 20px
    fontWeight()
    margin-bottom 24px
    img
      width 24px
      margin-right 6px
  .fromItem-box
    display flex
    flex-wrap wrap
  .row
    width calc(50% - 20px)
    margin-right 40px
    line-height 20px
    .name
      display flex
      font-size $f14
      margin-bottom 10px
      color $c1
      fontWeight()
      img
        width 14px
        margin 0 38px 0 8px
      .text
        color $c2
        font-weight 300
        margin-left 16px
    &:nth-of-type(2n)
      margin-right 0
  .api-row
    width 100%
    margin-bottom 32px
  .operation-box
    display flex
    margin-bottom 24px
    .btn-box
      width 130px
      .btn
        width 100%
        text-align center
        line-height 36px  
        font-size $f14
      .generation
        color $c7      
        background: linear-gradient(95deg, #FF8F10 0%, #FF7010 100%);
      .copy
        display flex
        justify-content center
        margin-top 12px
        .btnCopy
          color $c1
          cursor pointer
          line-height 15px
          display flex
          justify-content center
          .icon
            width 15px
            height 15px
            background-image url('../../assets/images/dynamic/copy.svg')
            background-size 100% 100%
            margin 0 12px 0 0
          &:hover
            color $c8
            .icon
              background-image url('../../assets/images/dynamic/copy-hover.svg')
    .textarea
      flex 1
      margin-left 32px
      .text
        background-color $c6
        padding 10px 20px
        font-size $f14
        color $c1
        line-height 32px
        height 120px
        border-radius 2px
        overflow auto
      .text1
        height 90px
        p
          word-break break-all
          word-wrap anywhere
    .qrcode-box
      display flex
      .textarea-box
        flex 1
        >>>.el-textarea__inner
          padding 14px 20px
          border none
        .btnQrcode
          display block
          margin 12px auto 6px auto
          border-radius 0        
        .socksName
          font-size $f12
          color $c2
          text-align center
      .qrcode-box
        width 160px
        height 160px
        border 1px dashed #D0CFCE
        margin-left 24px
        position relative
        padding 10px
        .emptyText
          position absolute
          top 50%
          left 50%
          transform translate3d(-50%, -50%, 0)
          color $c4   
          font-size $f14     
@media screen and (max-width: 800px)
  .miya-proxyCountry
    .title1
      margin-bottom 1rem
      line-height 1.5rem  
    .row
      width 100%
      margin-right 0
    .api-row
      .name
        display block
        img
          margin-right 7rem 
      .el-switch
        margin-top 0.5rem
    .operation-box
      margin-bottom 1.5rem
      display block
      .btn-box
        width 100%
        display flex
        margin-bottom 0.5rem
        .btn
          font-size 0.7rem
        .generation
          width 7rem
          font-size 1rem
        .copy
          width 7rem
      .textarea
        margin-left 0
        display block
        .textarea-box
          margin-bottom 0.5rem
        .qrcode-box
          margin 0 auto 1rem auto
      .miyaBtnInfo
        width 7rem !important
</style>
<style lang="stylus">
.miya-proxyCountry
  .fromItem-box
    .row
      .el-select
        width 100%
      .el-input-number--medium
        width 100%
      .el-input-number .el-input__inner
        text-align left
  .el-textarea.is-disabled .el-textarea__inner
    color $c1
@media screen and (max-width: 800px)
  .el-popper
    max-width calc(100% - 2rem)
</style>